<template>
    <div class="flex">
        <div class="text-left font-bold text-3xl text-gray-600">
            <div class="price-wrapper" v-show="!cartBtnDisabled">
                <span class="label-total">Gesamt: </span>{{ totalPrice }}
            </div>
        </div>
        <div class="text-right cart-btn-wrapper">
            <button v-show="(step > 1 && !cartBtnVisible)" @click="navigateBack" class="btn btn-primary--brand">Zurück</button>
            <button v-if="cartBtnVisible" class="btn btn-primary--brand" :disabled="cartBtnDisabled" @click="addToCart">In den Warenkorb</button>
            <button v-else class="btn btn-primary--brand" @click="navigateForward"
                :disabled="(soundFiles < 1) || step == 4 && (!selectedMaterial || !selectedFrameSize)">Weiter</button>
        </div>
    </div>
</template>

<script>
import Pipeline from "~/scripts/Pipeline/Pipeline.js";
import { mapFields } from 'vuex-map-fields';
import { moneyFormat} from "~/scripts/Pipeline/_helpers.js";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/animations/scale-subtle.css';

export default {
    props: {
        cartBtnClicked: false
    },

    data() {
        return {
            cartBtnTooltip: null
        }
    },

    computed: {
        ...mapFields({
            step: 'step',
            soundFiles: 'soundFiles',
            stepQrOpened: 'stepQrOpened',
            cartBtnClicked: 'cartBtnClicked',
            selectedMaterial: 'selectedMaterial',
            selectedFrameSize: 'selectedFrameSize'
        }),

        totalPrice() {
            let price = this.$store.getters.getTotalPrice;

            return moneyFormat(price);
        },

        cartBtnVisible() {
            return this.stepQrOpened;
        },

        cartBtnDisabled() {
            return this.$store.state.selectedFrameSize !== null && !this.cartBtnClicked ? false : 'disabled';
        }
    },

    mounted() {
        let trigger = this.$el.querySelector(".cart-btn-wrapper");
        let content = document.createElement('div');
        content.innerHTML = "Bitte wähle Material und Format in Schritt 4 um fortzufahren!";

        this.cartBtnTooltip = tippy(trigger, {
            content: content,
            theme: 'light',
            animation: 'scale-subtle'
        });
        this.cartBtnTooltip.disable();
    },

    methods: {
        async addToCart() {
            const state = this.$store.state;
            this.cartBtnClicked = true;
            this.$store.commit('generateUniqueId');

            this.$nextTick(async () => {
                await Pipeline.runQRCodePipeline(true);
                await Pipeline.clearConfiguratorFormFields();
                await Pipeline.uploadPortraitConfig();
                let element = document.getElementById('ayv-container');

                let productVarians = [];
                if (state.qrcode.use) {
                    productVarians.push("QR Code");

                    if (state.qrcode.voice) {
                        productVarians.push("Stimme anhören");
                    }

                    if(state.extraSound.use) {
                        productVarians.push("Zusätzliche Botschaft");
                    }

                    if(state.qrcode.usePassword) {
                        productVarians.push("Passwort");
                    }
                }

                if (state.digitalDownload.use) {
                    productVarians.push("Digitaler Download");
                }

                element.dispatchEvent(new CustomEvent("finalImageGenerated", {
                    detail: {
                        productCode: `${state.selectedMaterial.productCode}-${state.selectedFrameSize.width}x${state.selectedFrameSize.height}`,
                        price: this.$store.getters.getTotalPrice,
                        variants: productVarians,
                    }
                }));
                this.cartBtnClicked = false;
            });
        },

        navigateForward() {
            let element = document.getElementById('ayv-configurator-modal');
            element.dispatchEvent(new CustomEvent("navigateForward"));
        },

        navigateBack() {
            let element = document.getElementById('ayv-configurator-modal');
            element.dispatchEvent(new CustomEvent("navigateBack"));
        },

        enableTooltip() {
            if (this.cartBtnVisible && this.cartBtnDisabled === 'disabled') {
                this.cartBtnTooltip.enable();
            } else {
                this.cartBtnTooltip.disable();
            }
        }
    },

    watch: {
        selectedFrameSize() {
            this.cartBtnDisabled = this.$store.state.selectedFrameSize !== null && !this.cartBtnClicked ? false : 'disabled';
        },
        step() {
            this.enableTooltip();
        },
        cartBtnDisabled() {
            this.enableTooltip();
        }
    }
}
</script>
